import { Component, AfterViewInit } from '@angular/core';
import { Validators, FormControl, FormBuilder, FormGroup } from '@angular/forms';
import { ViewController } from 'ionic-angular';


import { AdminService } from '../../services/admin.service';
import { RegionService } from '../../services/region.service';

interface FormFormControlObject {
  [key: string]: FormControl;
}

@Component({
  selector: 'admin-keypad-page',
  templateUrl: 'admin-keypad.html'
})
export class AdminKeypadPage implements AfterViewInit {

  private keypadFormControlObject: FormFormControlObject;

  keypadFormObject: FormGroup;
  formIsReady: boolean;

  constructor(
    private formBuilder: FormBuilder,
    public regionService: RegionService,
    public adminService: AdminService,
    public viewCtrl: ViewController
  ) {

  }

  private generateFormControlObj(): FormFormControlObject {

    const keypadFormControlObject: FormFormControlObject = {};

    function buildFormControl(field: any): void {
      const validators: any[] = [];
      if (field.required) {
        validators.push(<any>Validators.required);
      }
      keypadFormControlObject[field.name] = new FormControl(
        field.model,
        validators
      );
    }

    buildFormControl(this.adminService.keypadInput);
    keypadFormControlObject[this.adminService.keypadInput.name].valueChanges.subscribe(
      (value: any) => (this.adminService.keypadInput.model = value)
    );

    keypadFormControlObject[this.adminService.keypadInput.name].setValue( this.adminService.keypadInput.model );

    return keypadFormControlObject;
  }

  private buildForm(): void {
    this.keypadFormControlObject = this.generateFormControlObj();
    this.keypadFormObject = this.formBuilder.group(this.keypadFormControlObject);

    setTimeout(() => {
      this.formIsReady = true;
    }, 300);
  }

  submit(formValues: any, valid: boolean): void {
    console.log(formValues, valid);
  }

  ngAfterViewInit(): void {
    this.buildForm();
  }

}



// WEBPACK FOOTER //
// ./src/pages/admin-keypad/admin-keypad.ts